export default __webpack_public_path__ + "static/media/CarDetailingHeavyCut.73814df6.webp";